<template>
  <div class="medal-manager">
    <div>
        自动发放提现免打扰：<el-checkbox v-model="checked"></el-checkbox><span style="color:red;margin-left:10px">从23:00到07:00停止自动发放提现！</span>
    </div>
    <div style="margin-top:10px;">
        提现代扣个人所得税比例：<el-tag type="info" style="margin-right:10px">20%</el-tag>*注：所有人的扣税比例都一样，包括大V
    </div>
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {

} from "../../api/api";

export default {
  components: { Toolbar },
  name: "MedalManager",
  data() {
    return {
      // 按钮列表
      buttonList: [],
      checked:false
    };
  },

  methods: {
   
   
  },
  mounted() {
    // 初始化按钮列表
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="stylus" scoped>
.medal-manager {
  padding: 20px;
}

.avatar-uploader {
  width: 178px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  /* margin: 0 auto; */
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c8c8c;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */

</style>